import { motion } from 'framer-motion';
import { Target, Plus, Users, Calendar, TrendingUp } from 'lucide-react';

import Header from '../components/Header';

export default function StrategyPage() {
  // const { companyId, strategyId } = useParams()

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <Header
        title="Strategy Name"
        subtitle="Company Name • Draft"
        actions={
          <div className="flex items-center space-x-4">
            <button className="text-gray-600 hover:text-gray-900">
              <Users className="h-5 w-5" />
            </button>
            <button className="bg-strategy-600 text-white px-4 py-2 rounded-lg hover:bg-strategy-700 transition-colors">
              Publish Strategy
            </button>
          </div>
        }
      />

      {/* Strategy Content */}
      <main className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Main Content */}
          <div className="lg:col-span-2 space-y-6">
            {/* Vision, Mission, Values */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="bg-white rounded-lg shadow p-6"
            >
              <h2 className="text-lg font-semibold text-gray-900 mb-4">Vision, Mission & Values</h2>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Vision</label>
                  <textarea
                    rows={2}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-strategy-500 focus:border-transparent"
                    placeholder="What does success look like for your company?"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Mission</label>
                  <textarea
                    rows={2}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-strategy-500 focus:border-transparent"
                    placeholder="What is your company's purpose and how do you achieve it?"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Core Values
                  </label>
                  <textarea
                    rows={2}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-strategy-500 focus:border-transparent"
                    placeholder="What principles guide your company's decisions?"
                  />
                </div>
              </div>
            </motion.div>

            {/* Objectives */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="bg-white rounded-lg shadow p-6"
            >
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg font-semibold text-gray-900">Strategic Objectives</h2>
                <button className="bg-objective-600 text-white px-3 py-1 rounded text-sm hover:bg-objective-700 transition-colors flex items-center">
                  <Plus className="h-4 w-4 mr-1" />
                  Add Objective
                </button>
              </div>

              {/* Empty State */}
              <div className="text-center py-12">
                <Target className="h-12 w-12 text-gray-400 mx-auto mb-4" />
                <h3 className="text-lg font-medium text-gray-900 mb-2">No objectives yet</h3>
                <p className="text-gray-600 mb-4">
                  Start by defining your key strategic objectives. Our AI can help generate them
                  based on your vision.
                </p>
                <button className="bg-objective-600 text-white px-4 py-2 rounded-lg hover:bg-objective-700 transition-colors">
                  Generate with AI
                </button>
              </div>
            </motion.div>
          </div>

          {/* Sidebar */}
          <div className="space-y-6">
            {/* Strategy Info */}
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              className="bg-white rounded-lg shadow p-6"
            >
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Strategy Overview</h3>
              <div className="space-y-3">
                <div className="flex items-center text-sm">
                  <Calendar className="h-4 w-4 text-gray-400 mr-2" />
                  <span className="text-gray-600">Created today</span>
                </div>
                <div className="flex items-center text-sm">
                  <Users className="h-4 w-4 text-gray-400 mr-2" />
                  <span className="text-gray-600">1 team member</span>
                </div>
                <div className="flex items-center text-sm">
                  <TrendingUp className="h-4 w-4 text-gray-400 mr-2" />
                  <span className="text-gray-600">0% complete</span>
                </div>
              </div>
            </motion.div>

            {/* Quick Actions */}
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.1 }}
              className="bg-white rounded-lg shadow p-6"
            >
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>
              <div className="space-y-2">
                <button className="w-full text-left px-3 py-2 rounded hover:bg-gray-50 transition-colors text-sm">
                  📊 Run SWOT Analysis
                </button>
                <button className="w-full text-left px-3 py-2 rounded hover:bg-gray-50 transition-colors text-sm">
                  🎯 Set Objectives
                </button>
                <button className="w-full text-left px-3 py-2 rounded hover:bg-gray-50 transition-colors text-sm">
                  👥 Invite Team Members
                </button>
                <button className="w-full text-left px-3 py-2 rounded hover:bg-gray-50 transition-colors text-sm">
                  🤖 Generate with AI
                </button>
              </div>
            </motion.div>
          </div>
        </div>
      </main>
    </div>
  );
}
